import {
  APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION,
  APPLICATION_ADD_PROCESS_DATACOLLECTION,
  APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP,
} from '../constants/ActionTypes.js'
import { Col, Glyphicon, Grid, Panel, Row, Tab, Tabs } from 'react-bootstrap'
import React, { Component } from 'react'

import { DataCollectionGroupPanel } from '../components/Mx/DataCollectionGroup/DataCollectionGroupPanel.js'
import DataCollectionListDataCollectionGroupPanel from '../components/Mx/DataCollectionGroup/DataCollectionListDataCollectionGroup/DataCollectionListDataCollectionGroupPanel.js'
import Form from 'react-jsonschema-form'
import Loader from 'react-loader-advanced'
import PropTypes from 'prop-types'
import UploadFilePanel from '../components/Analysis/UploadFilePanel.js'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import { loadJobs } from '../actions/jobs.js'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'

class AnalysisContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      schema: null,
      fething: false,
      fetched: false,
      input: {},
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.onFileUploaded = this.onFileUploaded.bind(this)
    this.getProccesingType = this.getProccesingType.bind(this)
  }

  onSubmit(form) {
    const _this = this
    this.setState({
      fething: true,
      fetched: false,
    })

    if (this.props.params.description) {
      this.props.params.description = this.props.params.description.replace(/_/g, ' ')
    }
    const input = Object.assign({}, this.state.input, form.formData, this.props.params)

    const data = {
      token: this.props.user.token,
      type: this.props.tool,
      username: this.props.user.username,
      input: input,
    }

    axios
      .post(this.props.configuration.dataAnalysis.url + '/jobs', data)
      .then(function () {
        _this.setState({
          fething: false,
          fetched: true,
        })
        _this.props.loadJobs(_this.props.user.username)
      })
      .catch(function () {
        _this.setState({
          fething: false,
          fetched: false,
        })
      })
  }

  /** ProcessingType is the entity involved in the processing: DataCollectionGroup, Datacollection, autoprocIntegration, etc... */
  getProccesingType() {
    if (this.props.params.autoprocintegrationId) {
      return APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION
    }

    if (this.props.params.datacollectiongroupid) {
      return APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP
    }

    if (this.props.params.datacollectionid) {
      return APPLICATION_ADD_PROCESS_DATACOLLECTION
    }

    return 'DATACOLLECTIONS'
  }

  getDatasetTab() {
    const _this = this

    switch (this.getProccesingType()) {
      case APPLICATION_ADD_PROCESS_DATACOLLECTION:
        var dataCollection = find(this.props.application.processingDataCollection, function (p) {
          return p.dataCollectionId === Number(_this.props.params.datacollectionid)
        })
        var proposal = find(this.props.proposals.data, { Proposal_proposalId: Number(dataCollection.proposalId) })
        return (
          <DataCollectionListDataCollectionGroupPanel
            user={this.props.user}
            proposal={proposal.Proposal_proposalCode + proposal.Proposal_proposalNumber}
            dataCollections={[dataCollection]}
          />
        )

      case APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP:
        var dataCollectionGroup = find(this.props.application.processingDataCollectionGroup, function (p) {
          return p.dataCollectionGroupId === Number(_this.props.params.datacollectiongroupid)
        })
        return (
          <DataCollectionGroupPanel
            proposal={dataCollectionGroup.proposal}
            user={this.props.user}
            configuration={this.props.configuration}
            application={this.props.application}
            datacollectiongroup={dataCollectionGroup}
          />
        )
      case APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION:
        return 'No data to be displayed'

      default:
        return 'No data to be displayed'
    }
  }

  /** this method will filter schema properties which type is file */
  filterFilesFromSchema(schema) {
    const properties = {}
    for (const key in schema.properties) {
      if (schema.properties[key].type !== 'file') {
        properties[key] = schema.properties[key]
      }
    }
    return properties
  }

  getFilesFromProperties(jobs, schema) {
    const files = filter(schema.properties, function (o) {
      return o.type === 'file'
    })
    schema.properties = this.filterFilesFromSchema(schema)
    return files
  }

  onFileUploaded(id) {
    this.setState(prevState => ({
      input: {
        ...prevState.input,
        name: id,
      },
    }))
  }

  render() {
    let jobs = []

    if (!this.props.user.token) {
      return null
    }

    switch (this.getProccesingType()) {
      case APPLICATION_ADD_PROCESS_DATACOLLECTION:
        jobs = this.props.jobs.datacollectionJobTypes
        break
      case APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP:
        jobs = this.props.jobs.datacollectionGroupJobTypes
        break
      case APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION:
        jobs = this.props.jobs.autoprocintegrationJobTypes
        break
      case 'DATACOLLECTIONS':
        jobs = this.props.jobs.datacollectionsJobTypes
        break
      default:
        jobs = []
    }

    if (this.state.fetching) {
      return (
        <Loader show={this.state.fetching} message="Sending Job to the Queue">
          ..
        </Loader>
      )
    }

    if (this.state.fetched) {
      return (
        <Panel bsStyle="success">
          <Panel.Body>
            <Grid>
              <Row className="show-grid">
                <Col xs={2} md={2} />
                <Col xs={2} md={2}>
                  <Glyphicon style={{ fontSize: '72px' }} glyph="send" />
                </Col>
                <Col xs={6} md={6}>
                  <span className="text-success" style={{ fontSize: '48px', fontWeight: 'bold' }}>
                    Job sent successfully
                  </span>
                </Col>
                <Col xs={2} md={2} />
              </Row>
            </Grid>
          </Panel.Body>
        </Panel>
      )
    }

    const tool = JSON.parse(JSON.stringify(jobs[this.props.tool]))
    const schema = tool.schema

    const files = this.getFilesFromProperties(jobs, schema)

    function getFileComponents(object, filesToUpload) {
      return (
        <div>
          {filesToUpload.map(file => (
            <UploadFilePanel
              key={file.name}
              onFileUploaded={object.onFileUploaded}
              description={file.description}
              name={file.name}
            />
          ))}
        </div>
      )
    }

    return (
      <Tabs id="processing" defaultActiveKey="job">
        <Tab eventKey="job" title="Job" style={{ margin: '20px' }}>
          <Grid>
            <Row>
              <Col xs={8} md={8}>
                <Form uiSchema={tool.uischema} formData={tool.formdata} schema={schema} onSubmit={this.onSubmit} />
              </Col>
              <Col xs={4} md={4}>
                {getFileComponents(this, files)}
              </Col>
            </Row>
          </Grid>
        </Tab>
        <Tab eventKey="Dataset" title="Data" style={{ margin: '20px' }}>
          {this.getDatasetTab()}
        </Tab>
      </Tabs>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    application: state.application,
    configuration: state.configuration,
    proposals: state.proposals,
    jobs: state.jobs,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
    loadJobs: username => dispatch(loadJobs(username)),
  }
}

AnalysisContainer.propTypes = {
  tool: PropTypes.string,
  params: PropTypes.array,
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalysisContainer)
